import { EmailType } from "../../../../../constants";
import { useSteps } from "../../../../../hook";

export const useMTPSteps = () => {
  return useSteps({
    approved: EmailType.MTPA,
    rejected: EmailType.MTPR,
    completed: EmailType.MTPF,
  });
};
